import { z } from 'zod'

/**
 * Product Visibility contract (Screen 5). Pinned to the backend's GET
 * /api/visibility response — the backend is being built to this exact shape in
 * parallel.
 *
 * READ-ONLY monitor: the authoritative sellable state is Shopify's
 * inventory_policy (CONTINUE = sellable, DENY = not sellable at 0). expected_*
 * mirrors the Inventory Planner's gate as advisory context; `divergent` is true
 * when expected_policy !== inventory_policy. The server pre-sorts divergent-first.
 *
 * price is a decimal STRING on the wire; keep it a string and format for display
 * without float math (no display-math on money).
 */

export const productStatusSchema = z.enum(['ACTIVE', 'DRAFT', 'ARCHIVED'])
export type ProductStatus = z.infer<typeof productStatusSchema>

export const inventoryPolicySchema = z.enum(['CONTINUE', 'DENY'])
export type InventoryPolicy = z.infer<typeof inventoryPolicySchema>

export const visibilityRowSchema = z.object({
  variant_id: z.string(),
  product_title: z.string(),
  variant_title: z.string().nullable(),
  sku: z.string(),
  ean: z.string().nullable(),
  price: z.string(),
  product_status: productStatusSchema,
  inventory_policy: inventoryPolicySchema,
  kh_stock: z.number().nullable(),
  end_of_life: z.boolean().nullable(),
  kh_checked_at: z.string().nullable(),
  in_kh_catalogue: z.boolean().nullable(),
  expected_policy: inventoryPolicySchema,
  expected_reason: z.string(),
  divergent: z.boolean(),
})
export type VisibilityRow = z.infer<typeof visibilityRowSchema>

export const visibilityResponseSchema = z.object({
  rows: z.array(visibilityRowSchema),
  generated_at: z.string(),
})
export type VisibilityResponse = z.infer<typeof visibilityResponseSchema>
